import { useEffect, useState } from 'react';

import { ProjectTaskType } from '@/entities/project';

import { Project } from '@/shared/types/Project';
import { Status } from '@/shared/types/Status';

import { TASK_CONSTANTS } from './constants/taskTypeConstants';
import { getInitialPercent } from './utils/getInitialPercent';
import { getIntervalForChangingPercents } from './utils/getIntervalForChangingPercents';

export const useTaskExecutionPercent = ({
  isFinalStatus = false,
  status,
  statusStartDate,
  taskType,
  videoDuration,
}: {
  isFinalStatus?: boolean;
  status: Project['status'];
  statusStartDate: Project['status_date'];
  taskType: Exclude<ProjectTaskType, 'voiceUpdate'>;
  videoDuration: Project['duration'];
}) => {
  const { finalPercentForStatus, wholeProcessSecFor60SecVideo } = TASK_CONSTANTS[taskType];

  // Костыль - voiceSuggestFailed приравниваем к voiceSuggestDone
  const modifiedStatus = status === Status.voiceSuggestFailed ? Status.voiceSuggestDone : status;

  const desiredPercent = getInitialPercent(modifiedStatus, statusStartDate, videoDuration, taskType);

  const [percent, setPercent] = useState(desiredPercent);

  useEffect(() => {
    if (isFinalStatus) {
      setPercent(100);

    }
  }, [isFinalStatus]);

  useEffect(() => {
    if (isFinalStatus) {
      return;
    }
    const intervalMs = getIntervalForChangingPercents(videoDuration, wholeProcessSecFor60SecVideo);
    if (desiredPercent <= percent) {
      return;
    }
    const interval = setInterval(() => {
      setPercent((prevState) => (prevState >= desiredPercent ? prevState : prevState + 1));
    }, Math.min(50, intervalMs));

    return () => {
      clearInterval(interval);
    };
  }, [isFinalStatus, desiredPercent, percent, videoDuration, wholeProcessSecFor60SecVideo]);

  useEffect(() => {
    if (isFinalStatus) {
      return;
    }
    const intervalMs = getIntervalForChangingPercents(videoDuration, wholeProcessSecFor60SecVideo);
    const finalPercentForCurrentStatus = finalPercentForStatus[modifiedStatus];

    if (!finalPercentForCurrentStatus || percent < desiredPercent) {
      return;
    }

    const interval = setInterval(() => {
      setPercent((prevState) => (prevState >= finalPercentForCurrentStatus ? prevState : prevState + 1));
    }, intervalMs);

    return () => {
      clearInterval(interval);
    };
  }, [
    isFinalStatus,
    modifiedStatus,
    percent,
    desiredPercent,
    videoDuration,
    finalPercentForStatus,
    wholeProcessSecFor60SecVideo,
  ]);

  return { percent, setPercent };
};
